import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid2";

import React from "react";
// Navigate
import { getProductInvoiceByUserIdAndDate } from "@/fetch/fetchProduct";
import { getAllStreet, getAllWorkLocation } from "@/fetch/fetchWork";
import getDateRange from "@/lib/getDateRange";
import TextField from "@mui/material/TextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";

import _ from "lodash";
export default function RosterLocationDialog(props) {
  const {
    onCancel,
    open,
    onSubmit,
    submitMessage,
    cancelMessage,
    deleteMessage = "刪除",
    onDelete,
    event,
    actions,
    events,
    handleOnChange,
    handleOnShopChange,
    submitButtonColor = "primary",
  } = props;

  const [options, setOptions] = React.useState([]);
  const [streetOptions, setStreetOptions] = React.useState([]);
  const originalValue = { ...event };
  const navigate = useNavigate();
  const { date } = useParams();
  const leaveTypes = [
    { label: "年假", value: "ANL", category: "請假", type: "leave" },
    { label: "病假", value: "PSL", category: "請假", type: "leave" },
    { label: "家庭假", value: "FAL", category: "請假", type: "leave" },
    { label: "無薪病假", value: "NPSL", category: "請假", type: "leave" },
    { label: "無薪假", value: "NPL", category: "請假", type: "leave" },
    { label: "生日假", value: "BIL", category: "請假", type: "leave" },
    { label: "4/5病假", value: "4/5SL", category: "請假", type: "leave" },
    { label: "恩恤假", value: "COL", category: "請假", type: "leave" },
    { label: "產假", value: "MATL", category: "請假", type: "leave" },
    { label: "婚假", value: "MARL", category: "請假", type: "leave" },
  ];

  const rosters = [
    {
      label: "全日更",
      value: "FULL",
    },
    {
      label: "A更",
      value: "A",
    },
    {
      label: "B更",
      value: "B",
    },
  ];
  const checkIsRosterExist = async (callback = () => {}, transfer) => {
    const dataRanges = getDateRange(event.start_date, event.end_date);

    const allExistDate = _.map(events, (e) => e.date);

    const duplicate = _.difference(
      dataRanges,
      _.difference(dataRanges, allExistDate)
    );
    if (duplicate.length > 0 && !event.title) {
      const answer = window.confirm(
        `於以下時間已有更期\n${duplicate.join(
          "\n"
        )} \n要確定繼續並取代以上日子嗎`
      );
      if (answer) {
        callback(transfer);
      }
    } else {
      callback(transfer);
    }
  };
  const fetch = async () => {
    const workLocarions = await getAllWorkLocation();
    const streets = await getAllStreet();
    const formattedOptions = _.map(workLocarions.data, (workLocarion) => {
      return {
        label: `${workLocarion.work_name} (${workLocarion.work_shortcode})`,
        value: String(workLocarion.id),
        category: "店鋪",
      };
    });
    const formattedStreetsOptions = _.map(streets.data, (s) => {
      return {
        label: `${s.street}`,
        value: s.street,
      };
    });
    setStreetOptions(formattedStreetsOptions);
    setOptions([
      { label: "Day Off", value: "OFF", category: "", type: "off" },
      { label: "勞工假", value: "SHD", category: "", type: "off" },
      ...leaveTypes,
      ...formattedOptions,
    ]);
  };
  React.useEffect(() => {
    fetch();
  }, []);
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
    >
      <DialogTitle>{event.title ? event.start_date : ""}</DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        <DialogContentText>
          <Box
            noValidate
            sx={{
              display: "grid",
              gridTemplateColumns: { sm: "1fr 1fr" },
              gap: 2,
            }}
          >
            {!event.title && (
              <>
                <FormControl fullWidth>
                  <DatePicker
                    disabled={!actions?.update}
                    required
                    id="startDate"
                    name="startDate"
                    label="開始日期"
                    minDate={moment(date, "YYYY-M").startOf("month")}
                    maxDate={moment(date, "YYYY-M").endOf("month")}
                    value={event.start_date}
                    onChange={(value) => {
                      handleOnChange(value, "start_date");
                    }}
                    renderInput={(params) => (
                      <TextField {...params} sx={{ width: "100%" }} />
                    )}
                  ></DatePicker>
                </FormControl>
                <FormControl fullWidth>
                  <DatePicker
                    disabled={!actions?.update}
                    required
                    id="endDate"
                    name="endDate"
                    label="結束日期"
                    minDate={event.start_date}
                    maxDate={moment(date, "YYYY-M").endOf("month")}
                    value={event.end_date}
                    onChange={(value) => {
                      handleOnChange(value, "end_date");
                    }}
                    renderInput={(params) => (
                      <TextField {...params} sx={{ width: "100%" }} />
                    )}
                  ></DatePicker>
                </FormControl>
              </>
            )}
            <FormControl fullWidth>
              <Autocomplete
                disabled={!actions?.update}
                required
                id="combo-box-demo"
                options={options}
                groupBy={(option) => option.category}
                label="店鋪"
                value={
                  options.find((option) => option.value === event.value) ?? null
                }
                onChange={(e, newValue) => {
                  let newFormValue = {};
                  if (newValue.type === "off") {
                    newFormValue = {
                      is_off: true,
                      is_leave: false,
                      off_type: newValue.value,
                      location_id: null,
                      roster: null,
                      value: newValue.value,
                    };
                  } else if (newValue.type === "leave") {
                    newFormValue = {
                      is_off: false,
                      is_leave: true,
                      leave_type: newValue.value,
                      location_id: null,
                      roster: null,
                      value: newValue.value,
                    };
                  } else {
                    newFormValue = {
                      is_off: false,
                      is_leave: false,
                      leave_type: null,
                      location_id: newValue.value,
                      value: newValue.value,
                      roster: event.roster_value ?? rosters[0].value,
                      remark: "",
                    };
                  }
                  handleOnShopChange(newFormValue);
                }}
                renderInput={(params) => <TextField {...params} label="店鋪" />}
              />
            </FormControl>
            {!event.is_leave && !event.is_off && (
              <>
                <FormControl fullWidth>
                  <Grid container spacing={2}>
                    <Grid size={6}>
                      <Autocomplete
                        disabled={!actions?.update}
                        required
                        id="combo-box-demo"
                        options={rosters}
                        value={
                          rosters.find(
                            (roster) => roster.value === event.roster_value
                          ) ?? rosters[0]
                        }
                        onChange={(event, newValue) => {
                          handleOnChange(newValue.value, "roster_value");
                        }}
                        label="Roster"
                        renderInput={(params) => (
                          <TextField {...params} label="Roster" />
                        )}
                        xs={6}
                      />
                    </Grid>
                    <Grid size={6}>
                      <Autocomplete
                        disabled={!actions?.update}
                        freeSolo
                        required
                        id="street"
                        options={streetOptions}
                        value={streetOptions.find(
                          (roster) => roster.value === event.street ?? ""
                        )}
                        onChange={(event, newValue) => {
                          handleOnChange(newValue.value, "street");
                        }}
                        label="street"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="街"
                            onChange={(e) => {
                              handleOnChange(e?.target?.value, "street");
                            }}
                          />
                        )}
                        xs={6}
                      />
                    </Grid>
                  </Grid>
                </FormControl>
                <FormControl fullWidth>
                  <Grid container spacing={2}>
                    <Grid size={6}>
                      <TimePicker
                        disabled={!actions?.update}
                        id="startTime"
                        name="startTime"
                        label="上班時間"
                        type="time"
                        value={event.start_time}
                        onChange={(value) => {
                          handleOnChange(value, "start_time");
                        }}
                        renderInput={(params) => (
                          <TextField {...params} sx={{ width: "100%" }} />
                        )}
                      ></TimePicker>
                    </Grid>
                    <Grid size={6}>
                      <TimePicker
                        disabled={!actions?.update}
                        id="endTime"
                        name="endTime"
                        label="下班時間"
                        type="time"
                        value={event.end_time}
                        onChange={(value) => {
                          handleOnChange(value, "end_time");
                        }}
                        renderInput={(params) => (
                          <TextField {...params} sx={{ width: "100%" }} />
                        )}
                      ></TimePicker>
                    </Grid>
                  </Grid>
                </FormControl>
                <FormControl fullWidth>
                  <TextField
                    disabled={!actions?.update}
                    id="lunch"
                    label="Lunch Time"
                    variant="outlined"
                    value={event.lunch}
                    onChange={(e) => handleOnChange(e.target.value, "lunch")}
                  />
                </FormControl>
              </>
            )}
            {(event.is_leave || event.is_off) && (
              <FormControl fullWidth>
                <TextField
                  disabled={!actions?.update}
                  id="remark"
                  label="Remark"
                  variant="outlined"
                  value={event.remark}
                  onChange={(e) => handleOnChange(e.target.value, "remark")}
                />
              </FormControl>
            )}
          </Box>
          {event.replace_user_id !== 0 && event.replace_user_id && (
            <Box>
              <FormControl fullWidth>
                <Button
                  onClick={() => {
                    onCancel();
                    navigate(`/roster/user/${event.replace_user_id}`);
                    navigate(0);
                  }}
                  variant="text"
                >
                  補更：{event.replace_full_name}
                </Button>
              </FormControl>
            </Box>
          )}
        </DialogContentText>
      </DialogContent>
      {actions?.update && (
        <DialogActions>
          <Button onClick={onCancel}>{cancelMessage}</Button>
          {event.user_id && (
            <Button onClick={onDelete} color={"error"} type="submit">
              {deleteMessage}
            </Button>
          )}
          <Button
            onClick={async () => {
              let transfer = false;

              if (
                originalValue.work_location_id &&
                event.is_leave &&
                event.is_off
              ) {
                const { data } = await getProductInvoiceByUserIdAndDate(
                  originalValue.user_id,
                  originalValue.work_location_id,
                  originalValue.date
                );

                if (data.length > 0) {
                  transfer = window.confirm(
                    `要將此日期的全部報數紀錄轉移到當前選擇的地點嗎？`
                  );
                }
              }

              checkIsRosterExist(onSubmit, transfer);
            }}
            color={submitButtonColor}
            type="submit"
          >
            {submitMessage}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}
